/**
 * @generated SignedSource<<ffdf74051293e95f0bd8c21a013acddd>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { InlineFragment, ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type helpersStyleArticle$data = {
  readonly sections: ReadonlyArray<{
    readonly value: ReadonlyArray<{
      readonly entityId: string;
    } | null> | null;
  } | null> | null;
  readonly " $fragmentType": "helpersStyleArticle";
};
export type helpersStyleArticle$key = {
  readonly " $data"?: helpersStyleArticle$data;
  readonly " $fragmentSpreads": FragmentRefs<"helpersStyleArticle">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "helpersStyleArticle"
};

(node as any).hash = "7867953a334870040bf69bf1730d5c81";

export default node;
